// Per-day uptime bars. Ported from design/rev3 (shell.jsx:122-138).
// Colour per day follows the §7/§15 formula via uptimeTone(); maintenance days
// use the idle tone with a distinct striped style.
import { uptimeTone } from '../lib/uptime'
import type { Tone } from '../lib/uptime'
import type { UptimeBar } from '../api/types'

// vitals.css exposes the status palette as --st-online/--st-warn/--st-offline/--st-idle.
const TONE_VAR: Record<Tone, string> = {
  online: 'var(--st-online)',
  warn: 'var(--st-warn)',
  offline: 'var(--st-offline)',
  idle: 'var(--st-idle)',
}

export function UptimeBars({ bars }: { bars: UptimeBar[] }) {
  return (
    <div style={{ display: 'flex', gap: 2, alignItems: 'stretch' }}>
      {bars.map((b, i) => {
        const tone = uptimeTone(b.uptimePercent)
        const background = b.hasMaintenance ? TONE_VAR.idle : TONE_VAR[tone]
        const pctLabel = b.uptimePercent ?? '—'
        return (
          <span
            key={`${b.date}-${i}`}
            data-bar
            title={`${b.date}: ${pctLabel}% · ${Math.round(b.outageMinutes)} min Ausfall`}
            style={{
              flex: 1,
              height: 38,
              borderRadius: 2,
              background,
              backgroundImage: b.hasMaintenance
                ? 'repeating-linear-gradient(45deg, var(--maint-stripe) 0 3px, transparent 3px 6px)'
                : undefined,
              opacity: b.hasMaintenance ? 0.6 : 1,
            }}
          />
        )
      })}
    </div>
  )
}
